(function productInfoRuntime(window, document) {
  'use strict';

  var w = window;
  var d = document;
  if (!w || !d || !w.customElements) return;

  // ---------------------------------------------------------------------------
  // Ownership
  // ---------------------------------------------------------------------------
  // product-info.js owns product-info behavior only.
  // Preferred file:
  // - assets/product-info.js
  //
  // Do not place in assets/global.js.
  // Do not define variant-selects here.
  // variant-selects belongs to assets/product-components-runtime.js.
  // product-info subscribes to optionValueSelectionChange published by variant-selects.
  //
  // Required relationship:
  // - variant-selects publishes optionValueSelectionChange
  // - product-info listens, fetches updated product HTML, swaps product DOM
  // - GFun refresh is delegated to GFunManager / GFunBalance facade only

  var GCITY = w.GCITY = w.GCITY || {};
  GCITY.product = GCITY.product || {};

  var PUB_SUB_EVENTS = w.PUB_SUB_EVENTS || {
    optionValueSelectionChange: 'option-value-selection-change',
    cartUpdate: 'cart-update',
    variantChange: 'variant-change',
    quantityUpdate: 'quantity-update'
  };

  var subscribe = typeof w.subscribe === 'function'
    ? w.subscribe.bind(w)
    : function subscribeFallback(eventName, callback) {
        function listener(event) {
          callback(event && event.detail ? event.detail : {});
        }
        d.addEventListener(eventName, listener);
        return function unsubscribeFallback() {
          d.removeEventListener(eventName, listener);
        };
      };

  var publish = typeof w.publish === 'function'
    ? w.publish.bind(w)
    : function publishFallback(eventName, payload) {
        d.dispatchEvent(new CustomEvent(eventName, { detail: payload || {} }));
        return Promise.resolve();
      };

  function warn() {
    if (w.console && typeof w.console.warn === 'function') w.console.warn.apply(w.console, arguments);
  }

  function cssEscape(value) {
    if (w.CSS && typeof w.CSS.escape === 'function') return w.CSS.escape(String(value));
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function getHTMLUpdateUtility() {
    if (GCITY.HTMLUpdateUtility && typeof GCITY.HTMLUpdateUtility.viewTransition === 'function') {
      return GCITY.HTMLUpdateUtility;
    }
    if (w.HTMLUpdateUtility && typeof w.HTMLUpdateUtility.viewTransition === 'function') {
      return w.HTMLUpdateUtility;
    }
    return {
      viewTransition: function viewTransitionFallback(oldNode, newNode, preProcessCallbacks, postProcessCallbacks) {
        if (!oldNode || !newNode || !oldNode.parentNode) return;
        preProcessCallbacks = preProcessCallbacks || [];
        postProcessCallbacks = postProcessCallbacks || [];
        preProcessCallbacks.forEach(function runPre(callback) { if (typeof callback === 'function') callback(newNode); });
        oldNode.replaceWith(newNode);
        postProcessCallbacks.forEach(function runPost(callback) { if (typeof callback === 'function') callback(newNode); });
      }
    };
  }

  function fetchHTML(url, signal) {
    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      signal: signal,
      headers: { 'Accept': 'text/html' }
    }).then(function parseResponse(response) {
      if (!response.ok) throw new Error('product_info_http_' + response.status);
      return response.text();
    });
  }

  function normalizeOptionValues(optionValues) {
    var seen = Object.create(null);
    return (Array.isArray(optionValues) ? optionValues : [])
      .map(function normalize(value) { return String(value || '').trim(); })
      .filter(function keep(value) {
        if (!value || seen[value]) return false;
        seen[value] = true;
        return true;
      });
  }

  function syncProductState(variant, html) {
    var current = (GCITY.product && GCITY.product.current) || {};
    var gfunPrice = Number(current.gfunPrice || 0);
    var rawPrice = Number(
      variant && typeof variant.price !== 'undefined'
        ? variant.price
        : current.rawPrice || current.price || 0
    );
    var tags = Array.isArray(current.tags) ? current.tags.slice() : [];

    if (html && typeof html.querySelector === 'function') {
      var gfunNode = html.querySelector('[data-gfun-cost]');
      if (gfunNode && gfunNode.dataset) {
        var nodeGfunPrice = Number(gfunNode.dataset.gfunCost);
        if (Number.isFinite(nodeGfunPrice)) gfunPrice = nodeGfunPrice;
      }
    }

    if (!Number.isFinite(gfunPrice)) gfunPrice = 0;
    if (!Number.isFinite(rawPrice)) rawPrice = 0;

    GCITY.product.current = Object.assign({}, current, {
      id: variant && variant.id ? variant.id : current.id || null,
      gfunPrice: gfunPrice,
      rawPrice: rawPrice,
      price: rawPrice,
      tags: tags
    });

    d.dispatchEvent(new CustomEvent('gcity:product-state-change', {
      detail: { source: 'product-info.js', product: GCITY.product.current }
    }));
  }

  function getSectionIdFor(sectionId, suffix) {
    if (w.SectionId && typeof w.SectionId.parseId === 'function' && typeof w.SectionId.getIdForSection === 'function') {
      return w.SectionId.getIdForSection(w.SectionId.parseId(sectionId), suffix);
    }
    return String(sectionId || '').replace(/main-product/i, suffix).replace(/MainProduct/i, suffix);
  }

  function refreshGFunBalanceIfNeeded(isGFunProduct) {
    if (!isGFunProduct) return;

    function runRefresh() {
      try {
        if (w.GFunManager && typeof w.GFunManager.fetchLatestBalance === 'function') {
          w.GFunManager.fetchLatestBalance(true).catch(function noop() {});
          return;
        }

        if (w.GFunBalance && typeof w.GFunBalance.fetchLatestBalance === 'function') {
          w.GFunBalance.fetchLatestBalance(true).catch(function noop() {});
          return;
        }

        if (w.GFunBalance && typeof w.GFunBalance.fetchBalance === 'function') {
          w.GFunBalance.fetchBalance(true).catch(function noop() {});
          return;
        }

        if (w.GFunBalance && typeof w.GFunBalance.updateGFunBalance === 'function') {
          w.GFunBalance.updateGFunBalance(true).catch(function noop() {});
        }
      } catch (_) {}
    }

    if (d.readyState === 'loading') {
      d.addEventListener('DOMContentLoaded', runRefresh, { once: true });
    } else {
      runRefresh();
    }
  }

  // ---------------------------------------------------------------------------
  // product-info
  // ---------------------------------------------------------------------------

  if (!customElements.get('product-info')) {
    customElements.define('product-info', class ProductInfo extends HTMLElement {
      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        this.quantityForm = undefined;
        this.onVariantChangeUnsubscriber = undefined;
        this.cartUpdateUnsubscriber = undefined;
        this.abortController = undefined;
        this.pendingRequestUrl = null;
        this.requestToken = 0;
        this.preProcessHtmlCallbacks = [];
        this.postProcessHtmlCallbacks = [];
      }

      connectedCallback() {
        if (this.__gcityProductInfoConnected) return;
        this.__gcityProductInfoConnected = true;

        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = PUB_SUB_EVENTS.optionValueSelectionChange
          ? subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, this.handleOptionValueChange.bind(this))
          : function noop() {};

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      disconnectedCallback() {
        if (typeof this.onVariantChangeUnsubscriber === 'function') this.onVariantChangeUnsubscriber();
        if (typeof this.cartUpdateUnsubscriber === 'function') this.cartUpdateUnsubscriber();
        if (this.abortController) this.abortController.abort();
        this.__gcityProductInfoConnected = false;
      }

      addPreProcessCallback(callback) {
        if (typeof callback === 'function') this.preProcessHtmlCallbacks.push(callback);
      }

      addPostProcessCallback(callback) {
        if (typeof callback === 'function') this.postProcessHtmlCallbacks.push(callback);
      }

      initializeProductSwapUtility() {
        if (this.__gcityProductSwapUtilityInit) return;
        this.__gcityProductSwapUtilityInit = true;

        this.preProcessHtmlCallbacks.push(function cancelScrollTriggers(html) {
          html.querySelectorAll('.scroll-trigger').forEach(function cancel(element) {
            element.classList.add('scroll-trigger--cancel');
          });
        });

        this.postProcessHtmlCallbacks.push(function initShopifyMedia() {
          if (w.Shopify && w.Shopify.PaymentButton && typeof w.Shopify.PaymentButton.init === 'function') {
            w.Shopify.PaymentButton.init();
          }
          if (w.ProductModel && typeof w.ProductModel.loadShopifyXR === 'function') {
            w.ProductModel.loadShopifyXR();
          }
        });
      }

      initQuantityHandlers() {
        this.quantityInput = this.querySelector('.product-block--quantity .quantity__input');
        if (!this.quantityInput) return;

        this.quantityForm = this.quantityInput.closest('.product-block--quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();

        if (!this.dataset.originalSection && PUB_SUB_EVENTS.cartUpdate) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      handleOptionValueChange(payload) {
        var data = payload && payload.data ? payload.data : {};
        var event = data.event;
        var target = data.target;
        var selectedOptionValues = data.selectedOptionValues || [];

        if (!event || !event.target || !this.contains(event.target)) return;

        this.resetProductFormState();

        var productUrl = target && target.dataset ? target.dataset.productUrl : '';
        productUrl = productUrl || this.pendingRequestUrl || this.dataset.url || w.location.pathname;

        this.pendingRequestUrl = productUrl;

        var shouldSwapProduct = this.dataset.url && this.dataset.url !== productUrl;
        var shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target && target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl)
        });
      }

      resetProductFormState() {
        var productForm = this.productForm;
        if (productForm && typeof productForm.toggleSubmitButton === 'function') productForm.toggleSubmitButton(true);
        if (productForm && typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return function handleSwap(html) {
          var modal = this.productModal;
          if (modal) modal.remove();

          var selector = updateFullPage ? 'product-info[id^="MainProduct"]' : 'product-info';
          var productInfoNode = html.querySelector(selector);
          if (!productInfoNode) return;

          var variant = this.getSelectedVariant(productInfoNode);
          this.updateURL(productUrl, variant && variant.id);

          var updater = getHTMLUpdateUtility();

          if (updateFullPage) {
            var newTitle = html.querySelector('head title');
            var currentTitle = d.querySelector('head title');
            if (newTitle && currentTitle) currentTitle.innerHTML = newTitle.innerHTML;

            var newMain = html.querySelector('main');
            var currentMain = d.querySelector('main');
            if (newMain && currentMain) updater.viewTransition(currentMain, newMain, this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks);
          } else {
            updater.viewTransition(this, productInfoNode, this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks);
          }
        }.bind(this);
      }

      renderProductInfo(params) {
        params = params || {};
        var requestUrl = params.requestUrl;
        var targetId = params.targetId;
        var callback = params.callback;

        if (!requestUrl || typeof callback !== 'function') return;

        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        this.requestToken += 1;
        var currentRequestToken = this.requestToken;
        var currentAbortController = this.abortController;

        fetchHTML(requestUrl, currentAbortController.signal)
          .then(function parseHTML(responseText) {
            if (this.requestToken !== currentRequestToken) return;
            if (this.abortController !== currentAbortController) return;
            this.pendingRequestUrl = null;
            var html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          }.bind(this))
          .then(function focusTarget() {
            if (this.requestToken !== currentRequestToken) return;
            if (this.abortController !== currentAbortController) return;
            if (!targetId) return;
            var target = d.querySelector('#' + cssEscape(targetId));
            if (target && typeof target.focus === 'function') target.focus();
          })
          .catch(function onError(error) {
            if (this.requestToken !== currentRequestToken) return;
            if (error && error.name === 'AbortError') return;
            warn(error);
          });
      }

      getSelectedVariant(productInfoNode) {
        if (!productInfoNode) return null;
        var selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]');
        var raw = selectedVariant ? selectedVariant.innerHTML : '';
        if (!raw) return null;
        try { return JSON.parse(raw); } catch (_) { return null; }
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage) {
        var parsed = new URL(url || w.location.pathname, w.location.origin);
        var normalizedOptionValues = normalizeOptionValues(optionValues);

        if (!shouldFetchFullPage) parsed.searchParams.set('section_id', this.sectionId);
        if (normalizedOptionValues.length) parsed.searchParams.set('option_values', normalizedOptionValues.join(','));

        return parsed.pathname + parsed.search + parsed.hash;
      }

      updateOptionValues(html) {
        var variantSelects = html.querySelector('variant-selects');
        if (variantSelects && this.variantSelectors) {
          getHTMLUpdateUtility().viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return function updateProduct(html) {
          var variant = this.getSelectedVariant(html);

          if (this.pickupAvailability && typeof this.pickupAvailability.update === 'function') {
            this.pickupAvailability.update(variant);
          }

          this.updateOptionValues(html);
          this.updateURL(productUrl, variant && variant.id);
          this.updateVariantInputs(variant && variant.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant.featured_media && variant.featured_media.id);

          var updateSourceFromDestination = function updateSourceFromDestination(id, shouldHide) {
            shouldHide = shouldHide || function alwaysShow() { return false; };
            var source = html.getElementById(id + '-' + this.sectionId);
            var destination = this.querySelector('#' + cssEscape(id + '-' + this.dataset.section));
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          }.bind(this);

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', function hideSku(source) { return source.classList.contains('hidden'); });
          updateSourceFromDestination('Inventory', function hideInventory(source) { return source.innerText === ''; });
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', function hidePpi(source) { return source.classList.contains('hidden'); });

          this.updateQuantityRules(this.sectionId, html);

          var quantityRules = this.querySelector('#' + cssEscape('Quantity-Rules-' + this.dataset.section));
          var volumeNote = this.querySelector('#' + cssEscape('Volume-Note-' + this.dataset.section));
          if (quantityRules) quantityRules.classList.remove('hidden');
          if (volumeNote) volumeNote.classList.remove('hidden');

          var submitButton = html.getElementById('ProductSubmitButton-' + this.sectionId);
          if (this.productForm && typeof this.productForm.toggleSubmitButton === 'function') {
            var submitDisabled = !submitButton || submitButton.hasAttribute('disabled');
            this.productForm.toggleSubmitButton(
              submitDisabled,
              submitDisabled ? (w.variantStrings && w.variantStrings.soldOut || 'Sold out') : null
            );
          }

          syncProductState(variant, html);

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html: html,
              variant: variant
            }
          });
        }.bind(this);
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll('#product-form-' + this.dataset.section + ', #product-form-installment-' + this.dataset.section)
          .forEach(function updateInput(productForm) {
            var input = productForm.querySelector('input[name="id"]');
            if (!input) return;
            input.value = variantId || '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
      }

updateURL(url, variantId) {
  var shareButton = this.querySelector('share-button');
  var shopUrl = w.shopUrl || w.location.origin;
  var nextUrl;

  try {
    nextUrl = new URL(url, shopUrl);
  } catch (_) {
    return;
  }

  if (variantId) {
    nextUrl.searchParams.set('variant', variantId);
  } else {
    nextUrl.searchParams.delete('variant');
  }

  var relativeUrl =
    nextUrl.pathname +
    nextUrl.search +
    nextUrl.hash;

  if (shareButton && typeof shareButton.updateUrl === 'function') {
    shareButton.updateUrl(nextUrl.toString());
  }

  if (this.dataset.updateUrl === 'false') return;

  w.history.replaceState(
    w.history.state,
    '',
    relativeUrl
  );
}


      setUnavailable() {
        if (this.productForm && typeof this.productForm.toggleSubmitButton === 'function') {
          this.productForm.toggleSubmitButton(true, w.variantStrings && w.variantStrings.unavailable || 'Unavailable');
        }

        ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map(function mapSelector(id) { return '#' + cssEscape(id + '-' + this.dataset.section); }, this)
          .forEach(function hide(selector) {
            d.querySelectorAll(selector).forEach(function hideNode(node) { node.classList.add('hidden'); });
          });
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        var mediaGallerySource = this.querySelector('media-gallery ul');
        var mediaGalleryDestination = html.querySelector('media-gallery ul');

        var refreshSourceData = function refreshSourceData() {
          if (this.hasAttribute('data-zoom-on-hover') && typeof w.enableZoomOnHover === 'function') w.enableZoomOnHover(2);
          var sourceItems = mediaGallerySource ? Array.prototype.slice.call(mediaGallerySource.querySelectorAll('li[data-media-id]')) : [];
          var sourceSet = new Set(sourceItems.map(function mapId(item) { return item.dataset.mediaId; }));
          var sourceMap = new Map(sourceItems.map(function mapItem(item, index) { return [item.dataset.mediaId, { item: item, index: index }]; }));
          return [sourceItems, sourceSet, sourceMap];
        }.bind(this);

        if (mediaGallerySource && mediaGalleryDestination) {
          var data = refreshSourceData();
          var sourceItems = data[0];
          var sourceSet = data[1];
          var sourceMap = data[2];
          var destinationItems = Array.prototype.slice.call(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
          var destinationSet = new Set(destinationItems.map(function mapDestinationId(item) { return item.dataset.mediaId; }));
          var shouldRefresh = false;

          for (var i = destinationItems.length - 1; i >= 0; i -= 1) {
            if (!sourceSet.has(destinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(destinationItems[i]);
              shouldRefresh = true;
            }
          }

          for (var j = 0; j < sourceItems.length; j += 1) {
            if (!destinationSet.has(sourceItems[j].dataset.mediaId)) {
              sourceItems[j].remove();
              shouldRefresh = true;
            }
          }

          if (shouldRefresh) {
            data = refreshSourceData();
            sourceItems = data[0];
            sourceSet = data[1];
            sourceMap = data[2];
          }

          destinationItems.forEach(function sortMedia(destinationItem, destinationIndex) {
            var sourceData = sourceMap.get(destinationItem.dataset.mediaId);
            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(sourceData.item, mediaGallerySource.querySelector('li:nth-of-type(' + (destinationIndex + 1) + ')'));
              data = refreshSourceData();
              sourceItems = data[0];
              sourceSet = data[1];
              sourceMap = data[2];
            }
          });
        }

        var gallery = this.querySelector('media-gallery');
        if (gallery && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(this.dataset.section + '-' + variantFeaturedMediaId, true);
        }

        var modalContent = this.productModal && this.productModal.querySelector('.product-media-modal__content');
        var newModalContent = html.querySelector('product-modal .product-media-modal__content');
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        if (!this.quantityInput) return;

        var minAttribute = parseInt(this.quantityInput.getAttribute('min'), 10);
        var maxAttribute = parseInt(this.quantityInput.getAttribute('max'), 10);
        var stepAttribute = parseInt(this.quantityInput.getAttribute('step'), 10);
        var data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity, 10) : 0,
          min: Number.isFinite(minAttribute) ? minAttribute : 1,
          max: Number.isFinite(maxAttribute) ? maxAttribute : null,
          step: Number.isFinite(stepAttribute) && stepAttribute > 0 ? stepAttribute : 1
        };

        var min = data.min;
        var max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max !== null) this.quantityInput.max = max;
        else this.quantityInput.removeAttribute('max');

        this.quantityInput.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        var currentVariantId = this.productForm && this.productForm.variantIdInput ? this.productForm.variantIdInput.value : '';
        if (!currentVariantId) return;

        var spinner = this.querySelector('.quantity__rules-cart .loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        return fetchHTML(this.dataset.url + '?variant=' + encodeURIComponent(currentVariantId) + '&section_id=' + encodeURIComponent(this.dataset.section))
          .then(function parseRules(responseText) {
            var html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          }.bind(this))
          .catch(function onError(error) { warn(error); })
          .finally(function hideSpinner() {
            if (spinner) spinner.classList.add('hidden');
          });
      }

      updateQuantityRules(_sectionId, html) {
        if (!this.quantityInput || !this.quantityForm || !html) return;

        var quantityFormUpdated = html.querySelector('product-info[data-module="main-product"] .product-block--quantity')
          || html.querySelector('.product-block--quantity');
        if (!quantityFormUpdated) return;

        ['.quantity__input', '.quantity__rules', '.quantity__label'].forEach(function updateSelector(selector) {
          var current = this.quantityForm.querySelector(selector);
          var updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) return;

          if (selector === '.quantity__input') {
            ['min', 'max', 'step', 'data-cart-quantity'].forEach(function syncAttribute(attribute) {
              var valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
              else current.removeAttribute(attribute);
            });
            return;
          }

          current.innerHTML = updated.innerHTML;

          if (selector === '.quantity__label') {
            var updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
            if (updatedAriaLabelledBy) {
              current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
              var currentHiddenLabel = d.getElementById(updatedAriaLabelledBy);
              var updatedHiddenLabel = html.getElementById(updatedAriaLabelledBy);
              if (currentHiddenLabel && updatedHiddenLabel) currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
            }
          }
        }, this);

        this.setQuantityBoundries();
      }

      get productForm() {
        return this.querySelector('product-form');
      }

      get productModal() {
        return d.querySelector('#' + cssEscape('ProductModal-' + this.dataset.section));
      }

      get pickupAvailability() {
        return this.querySelector('pickup-availability');
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        var relatedProductsSectionId = getSectionIdFor(this.sectionId, 'related-products');
        return d.querySelector('product-recommendations[data-section-id^="' + cssEscape(relatedProductsSectionId) + '"]');
      }

      get quickOrderList() {
        var quickOrderListSectionId = getSectionIdFor(this.sectionId, 'quick_order_list');
        return d.querySelector('quick-order-list[data-id^="' + cssEscape(quickOrderListSectionId) + '"]');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    });
  }

  // Product state lives under GCITY.product.current; no mirrored price/tag globals.
  (function initializeProductRuntime() {
    var productRuntime = (GCITY.product && GCITY.product.current) || {};
    var requiresGfunFromMeta = !!d.querySelector('[data-requires-gfun="true"]');
    refreshGFunBalanceIfNeeded(
      !!productRuntime.isGFunOnly || !!productRuntime.isDualPrice || requiresGfunFromMeta
    );
  })();


  d.dispatchEvent(new CustomEvent('gcity:product-info-ready', {
    detail: { source: 'product-info.js' }
  }));
})(window, document);
